<gt-header *ngIf="showHeader"></gt-header>
<ion-content>
  @if (currentEdition$ | async; as currentEdition) {
    @if (currentEdition.enableInscriptions) {
      <div class="flex items-center justify-between">
        <div *ngIf="!showHeader"></div>
        <ion-icon *ngIf="showHeader" class="text-size-32" name="gt-back" (click)="navController.back()"></ion-icon>
        <div class="uppercase font-semibold text-lg">{{ 'ONBOARDING.REGISTER.TITLE' | transloco }}</div>
        <div class="w-8"></div>
      </div>
      <form [formGroup]="registerForm" class="flex flex-col gap-2">
        <hr />
        <div class="flex flex-col gap-4">
          <h3>{{ 'ONBOARDING.REGISTER.TITLE_TEAM' | transloco }}</h3>
          <ion-input
            fill="solid"
            labelPlacement="floating"
            formControlName="teamName"
            [label]="'ONBOARDING.REGISTER.TEAM_NAME' | transloco"
            [errorText]="'ERROR.REQUIRED' | transloco"
          ></ion-input>
          <ion-input
            fill="solid"
            labelPlacement="floating"
            formControlName="webUrl"
            [label]="'ONBOARDING.REGISTER.URL_WEB' | transloco"
          ></ion-input>
          <ion-input
            fill="solid"
            labelPlacement="floating"
            formControlName="socialUrl"
            [label]="'ONBOARDING.REGISTER.URL_FACEBOOK' | transloco"
          ></ion-input>
        </div>
        <hr />
        <div class="flex flex-col gap-4">
          <h3>{{ 'ONBOARDING.REGISTER.TITLE_PILOT' | transloco }}</h3>
          <div class="flex flex-col gap-4" formGroupName="pilot">
            <ion-input
              fill="solid"
              labelPlacement="floating"
              type="email"
              formControlName="email"
              [helperText]="'ONBOARDING.REGISTER.EMAIL_HELPER_TEXT' | transloco"
              [label]="'ONBOARDING.REGISTER.EMAIL' | transloco"
              [errorText]="'ERROR.REQUIRED_OR_FORMAT' | transloco"
              email
            ></ion-input>
            <div>
              <ion-input
                *ngIf="(user$ | async) === null"
                fill="solid"
                type="password"
                formControlName="password"
                [placeholder]="'ONBOARDING.REGISTER.PASSWORD' | transloco"
              >
                <ion-input-password-toggle color="dark" slot="end"></ion-input-password-toggle>
              </ion-input>
              <p class="cursor-pointer logout" *ngIf="!showHeader && (user$ | async) !== null">
                <span (click)="logout()">{{ 'ONBOARDING.REGISTER.CHANGE_EMAIL_LOGOUT' | transloco }}</span>
              </p>
            </div>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="fullName"
              [label]="'ONBOARDING.REGISTER.FULL_NAME' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              readonly
              [label]="'ONBOARDING.REGISTER.NATIONALITY' | transloco"
              formControlName="nationality"
              (click)="openNationalityModal('pilot')"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              type="date"
              formControlName="birthday"
              [label]="'ONBOARDING.REGISTER.BIRTHDAY' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="documentNumber"
              [label]="'ONBOARDING.REGISTER.DOCUMENT_NUMBER' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="passport"
              [label]="'ONBOARDING.REGISTER.PASSPORT' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              type="date"
              formControlName="passportExpiration"
              [label]="'ONBOARDING.REGISTER.PASSPORT_EXPIRATION' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <div class="flex gap-1">
              <ion-input
                fill="solid"
                labelPlacement="floating"
                readonly
                [label]="'ONBOARDING.REGISTER.DIAL_CODE' | transloco"
                formControlName="dialCode"
                (click)="openDialModal('pilot')"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="phone"
                [label]="'ONBOARDING.REGISTER.PHONE' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
            </div>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="address"
              [label]="'ONBOARDING.REGISTER.ADDRESS' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="city"
              [label]="'ONBOARDING.REGISTER.CITY' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="zipCode"
              [label]="'ONBOARDING.REGISTER.ZIP_CODE' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="state"
              [label]="'ONBOARDING.REGISTER.STATE' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
          </div>
        </div>
        <hr />
        <div>
          <ion-radio-group class="flex flex-col gap-5" formControlName="firstTime">
            <div class="flex gap-2">
              <ion-radio mode="md" [value]="true" labelPlacement="end"></ion-radio>
              <div>{{ 'ONBOARDING.REGISTER.FIRST_TIME_TRUE' | transloco }}</div>
            </div>
            <div class="flex gap-2">
              <ion-radio mode="md" [value]="false" labelPlacement="end"></ion-radio>
              <div>{{ 'ONBOARDING.REGISTER.FIRST_TIME_FALSE' | transloco }}</div>
            </div>
          </ion-radio-group>
          <ion-input
            *ngIf="registerForm.value.firstTime === false"
            fill="solid"
            labelPlacement="floating"
            formControlName="times"
            [label]="'ONBOARDING.REGISTER.TIMES' | transloco"
            [errorText]="'ERROR.REQUIRED' | transloco"
          ></ion-input>
        </div>
        <hr />
        <div class="flex flex-col gap-8">
          <div class="flex justify-between items-center">
            <h3>{{ 'ONBOARDING.REGISTER.TITLE_COPILOT' | transloco }}</h3>
            <gt-button size="s" (click)="toggleCopilot()">
              {{
                hasCopilot
                  ? ('ONBOARDING.REGISTER.REMOVE_COPILOT' | transloco)
                  : ('ONBOARDING.REGISTER.ADD_COPILOT' | transloco)
              }}
            </gt-button>
          </div>
          <div *ngIf="hasCopilot" class="flex flex-col gap-4" formGroupName="copilot">
            <ion-input
              fill="solid"
              labelPlacement="floating"
              type="email"
              formControlName="email"
              [helperText]="'ONBOARDING.REGISTER.EMAIL_HELPER_TEXT' | transloco"
              [label]="'ONBOARDING.REGISTER.EMAIL' | transloco"
              [errorText]="'ERROR.REQUIRED_OR_FORMAT' | transloco"
              email
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="fullName"
              [label]="'ONBOARDING.REGISTER.FULL_NAME' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              readonly
              [label]="'ONBOARDING.REGISTER.NATIONALITY' | transloco"
              formControlName="nationality"
              (click)="openNationalityModal('copilot')"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              type="date"
              formControlName="birthday"
              [label]="'ONBOARDING.REGISTER.BIRTHDAY' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="documentNumber"
              [label]="'ONBOARDING.REGISTER.DOCUMENT_NUMBER' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="passport"
              [label]="'ONBOARDING.REGISTER.PASSPORT' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              type="date"
              formControlName="passportExpiration"
              [label]="'ONBOARDING.REGISTER.PASSPORT_EXPIRATION' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <div class="flex gap-1">
              <ion-input
                fill="solid"
                labelPlacement="floating"
                readonly
                [label]="'ONBOARDING.REGISTER.DIAL_CODE' | transloco"
                formControlName="dialCode"
                (click)="openDialModal('copilot')"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="phone"
                [label]="'ONBOARDING.REGISTER.PHONE' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
            </div>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="address"
              [label]="'ONBOARDING.REGISTER.ADDRESS' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="city"
              [label]="'ONBOARDING.REGISTER.CITY' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="zipCode"
              [label]="'ONBOARDING.REGISTER.ZIP_CODE' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="state"
              [label]="'ONBOARDING.REGISTER.STATE' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
          </div>
        </div>
        <hr />
        <div *ngIf="participants.length <= 0" class="flex flex-col gap-8">
          <h3>{{ 'ONBOARDING.REGISTER.ADD_TITLE' | transloco }}</h3>
          <gt-button [disabled]="!hasCopilot" (click)="addParticipant()">{{
            'ONBOARDING.REGISTER.ADD_PARTICIPANT_BUTTON' | transloco
          }}</gt-button>
          <p *ngIf="!hasCopilot" class="text-sm opacity-70">
            {{ 'ONBOARDING.REGISTER.COPILOT_REQUIRED_FIRST' | transloco }}
          </p>
        </div>
        <div formArrayName="participants">
          <div *ngFor="let participant of participants.controls; let last = last; let i = index">
            <h3>{{ 'ONBOARDING.REGISTER.PARTICIPANT' + i | transloco }}</h3>
            <div class="flex flex-col gap-4" [formGroupName]="i">
              <ion-input
                fill="solid"
                labelPlacement="floating"
                type="email"
                formControlName="email"
                [helperText]="'ONBOARDING.REGISTER.EMAIL_HELPER_TEXT' | transloco"
                [label]="'ONBOARDING.REGISTER.EMAIL' | transloco"
                [errorText]="'ERROR.REQUIRED_OR_FORMAT' | transloco"
                email
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="fullName"
                [label]="'ONBOARDING.REGISTER.FULL_NAME' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                readonly
                [label]="'ONBOARDING.REGISTER.NATIONALITY' | transloco"
                formControlName="nationality"
                (click)="openNationalityModal(i)"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                type="date"
                formControlName="birthday"
                [label]="'ONBOARDING.REGISTER.BIRTHDAY' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="documentNumber"
                [label]="'ONBOARDING.REGISTER.DOCUMENT_NUMBER' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="passport"
                [label]="'ONBOARDING.REGISTER.PASSPORT' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                type="date"
                formControlName="passportExpiration"
                [label]="'ONBOARDING.REGISTER.PASSPORT_EXPIRATION' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <div class="flex gap-1">
                <ion-input
                  fill="solid"
                  labelPlacement="floating"
                  readonly
                  [label]="'ONBOARDING.REGISTER.DIAL_CODE' | transloco"
                  formControlName="dialCode"
                  (click)="openDialModal(i)"
                ></ion-input>
                <ion-input
                  fill="solid"
                  labelPlacement="floating"
                  formControlName="phone"
                  [label]="'ONBOARDING.REGISTER.PHONE' | transloco"
                  [errorText]="'ERROR.REQUIRED' | transloco"
                ></ion-input>
              </div>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="address"
                [label]="'ONBOARDING.REGISTER.ADDRESS' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="city"
                [label]="'ONBOARDING.REGISTER.CITY' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="zipCode"
                [label]="'ONBOARDING.REGISTER.ZIP_CODE' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="state"
                [label]="'ONBOARDING.REGISTER.STATE' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <div class="flex items-center gap-3 text-danger justify-center" (click)="removeParticipant(i)">
                <img src="/assets/icon/custom-icons/gt-trash.svg" />
                {{ 'ONBOARDING.REGISTER.DELETE_TITLE' | transloco }}
              </div>
              <hr *ngIf="!last" />
            </div>
            <div *ngIf="last && canAddParticipant" class="flex flex-col gap-8">
              <h3>{{ 'ONBOARDING.REGISTER.ADD_TITLE' | transloco }}</h3>
              <gt-button (click)="addParticipant()">{{
                'ONBOARDING.REGISTER.ADD_PARTICIPANT_BUTTON' | transloco
              }}</gt-button>
            </div>
          </div>
        </div>
        <hr />
        <div class="flex flex-col gap-8">
          <h3>{{ 'ONBOARDING.REGISTER.TITLE_VEHICLE' | transloco }}</h3>
          @if (edition && edition.premiumPacks && edition.premiumPacks.length > 0) {
            <div class="flex gap-2">
              <ion-checkbox
                formControlName="isPremium"
                (ionChange)="setVehicleValidators($event.target.checked)"
              ></ion-checkbox>
              <div>{{ 'ONBOARDING.REGISTER.PREMIUM' | transloco }}</div>
            </div>
          }
          <div class="flex flex-col gap-4">
            @if (currentLanguage$ | async; as currentLang) {
              <ion-select
                toggleIcon="chevron-down"
                expandedIcon="chevron-up"
                labelPlacement="stacked"
                interface="alert"
                mode="ios"
                fill="solid"
                label="{{ 'ONBOARDING.REGISTER.CATEGORY' | transloco }}"
                formControlName="category"
              >
                <ion-select-option [value]="category.id" color="dark" *ngFor="let category of categories$ | async">
                  {{ getCategoryTranslation(category.name, category.translations, currentLang) }}
                </ion-select-option>
              </ion-select>
            }

            <ion-select
              *ngIf="!registerForm.value.isPremium"
              toggleIcon="chevron-down"
              expandedIcon="chevron-up"
              labelPlacement="stacked"
              interface="alert"
              mode="ios"
              fill="solid"
              label="{{ 'ONBOARDING.REGISTER.VEHICLE_TYPE' | transloco }}"
              formControlName="vehicleType"
            >
              <ion-select-option value="4x2">4x2</ion-select-option>
              <ion-select-option value="4x4">4x4</ion-select-option>
            </ion-select>
            <ion-select
              *ngIf="registerForm.value.isPremium"
              toggleIcon="chevron-down"
              expandedIcon="chevron-up"
              labelPlacement="stacked"
              interface="alert"
              mode="ios"
              fill="solid"
              label="{{ 'ONBOARDING.REGISTER.VEHICLES' | transloco }}"
              formControlName="premiumPack"
            >
              <ion-select-option [value]="premiumPack" color="dark" *ngFor="let premiumPack of premiumPacks$ | async"
                >{{ premiumPack.name }} - {{ premiumPack.price | currency: 'EUR' }}</ion-select-option
              >
            </ion-select>
            @if (!registerForm.value.isPremium) {
              <ion-input
                fill="solid"
                labelPlacement="floating"
                readonly
                [label]="'ONBOARDING.REGISTER.VEHICLE_BRAND' | transloco"
                [value]="selectedVehicleBrandLabel"
                (click)="openVehicleBrandModal()"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              @if (registerForm.value.vehicleBrand === 'OTHER') {
                <ion-input
                  fill="solid"
                  labelPlacement="floating"
                  formControlName="otherVehicleBrand"
                  [label]="'ONBOARDING.REGISTER.VEHICLE_BRAND' | transloco"
                  [errorText]="'ERROR.REQUIRED' | transloco"
                ></ion-input>
              }
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="vehicleModel"
                [label]="'ONBOARDING.REGISTER.VEHICLE_MODEL' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="vehicleYear"
                [label]="'ONBOARDING.REGISTER.VEHICLE_YEAR' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="vehicleCC"
                [label]="'ONBOARDING.REGISTER.VEHICLE_CC' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="vehicleCV"
                [label]="'ONBOARDING.REGISTER.VEHICLE_CV' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="vehiclePlateNumber"
                [label]="'ONBOARDING.REGISTER.VEHICLE_PLATE_NUMBER' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
              <ion-input
                fill="solid"
                labelPlacement="floating"
                formControlName="vehicleGps"
                [label]="'ONBOARDING.REGISTER.VEHICLE_GPS' | transloco"
                [errorText]="'ERROR.REQUIRED' | transloco"
              ></ion-input>
            }
          </div>
        </div>
        <hr />

        <div class="flex flex-col">
          <h3>{{ 'ONBOARDING.REGISTER.COMMENTS' | transloco }}</h3>
          <div class="flex gap-2">
            <ion-textarea
              [label]="'ONBOARDING.REGISTER.COMMENTS' | transloco"
              formControlName="userComments"
              fill="solid"
              labelPlacement="floating"
              rows="2"
            ></ion-textarea>
          </div>
        </div>
        <hr />
        <div>
          <h3>{{ 'ONBOARDING.REGISTER.BILLING_TITLE' | transloco }}</h3>
          <div>
            <p class="font-bold uppercase">{{ 'ONBOARDING.REGISTER.BILLING_DESC_BOLD' | transloco }}</p>
            <p>{{ 'ONBOARDING.REGISTER.BILLING_DESC' | transloco }}</p>
          </div>
          <div>
            <ion-radio-group
              class="my-5 flex flex-col gap-5"
              formControlName="useBillingData"
              (ionChange)="setBillingValidators($event.target.value)"
            >
              <div class="flex gap-2">
                <ion-radio mode="md" [value]="true" labelPlacement="end"></ion-radio>
                <div>{{ 'ONBOARDING.REGISTER.BILLING_DATA_OPTION1' | transloco }}</div>
              </div>
              <div class="flex gap-2">
                <ion-radio mode="md" [value]="false" labelPlacement="end"></ion-radio>
                <div>{{ 'ONBOARDING.REGISTER.BILLING_DATA_OPTION2' | transloco }}</div>
              </div>
            </ion-radio-group>
          </div>
          <div *ngIf="!registerForm.value.useBillingData" formGroupName="billing" class="flex flex-col gap-4">
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="name"
              [label]="'ONBOARDING.REGISTER.BILLING_NAME' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="cif"
              [label]="'ONBOARDING.REGISTER.BILLING_CIF' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="address"
              [label]="'ONBOARDING.REGISTER.ADDRESS' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="zipCode"
              [label]="'ONBOARDING.REGISTER.ZIP_CODE' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="city"
              [label]="'ONBOARDING.REGISTER.CITY' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
            <ion-input
              fill="solid"
              labelPlacement="floating"
              formControlName="country"
              [label]="'ONBOARDING.REGISTER.COUNTRY' | transloco"
              [errorText]="'ERROR.REQUIRED' | transloco"
            ></ion-input>
          </div>
        </div>
        <div class="my-5 flex flex-col gap-4">
          <div class="flex gap-2">
            <ion-checkbox formControlName="mailing" labelPlacement="end"></ion-checkbox>
            <div>{{ 'ONBOARDING.REGISTER.MAILING' | transloco }}</div>
          </div>
          <div class="flex gap-2">
            <ion-checkbox formControlName="privacy"></ion-checkbox>
            <div>
              @if (environment.platform === 'app') {
                {{ 'ONBOARDING.REGISTER.PREFIX_PRIVACY_LINK' | transloco }}
                <a class="font-bold underline" [routerLink]="['/legal/cancellation']">{{
                  'ONBOARDING.REGISTER.CANCEL_LINK' | transloco
                }}</a>
                {{ 'ONBOARDING.REGISTER.POST_CANCEL_LINK' | transloco }}
                <a class="font-bold underline" [routerLink]="['/legal/privacy']">{{
                  'ONBOARDING.REGISTER.PRIVACY_LINK' | transloco
                }}</a>
              } @else if (environment.platform === 'web') {
                {{ 'ONBOARDING.REGISTER.PREFIX_PRIVACY_LINK' | transloco }}
                <a class="font-bold underline cursor-pointer" (click)="goToLegalWebPage('politica-de-cancelacion')">{{
                  'ONBOARDING.REGISTER.CANCEL_LINK' | transloco
                }}</a>
                {{ 'ONBOARDING.REGISTER.POST_CANCEL_LINK' | transloco }}
                <a class="font-bold underline cursor-pointer" (click)="goToLegalWebPage('privacidad')">{{
                  'ONBOARDING.REGISTER.PRIVACY_LINK' | transloco
                }}</a>
              }
            </div>
          </div>
        </div>
        <div class="flex justify-center">
          <gt-button [disabled]="loading" class="send-button" (click)="confirmInscription()">
            {{ 'ONBOARDING.REGISTER.SEND' | transloco }}
          </gt-button>
        </div>
      </form>
    } @else {
      <div class="flex flex-col items-center justify-center gap-10">
        <img height="64" class="h-16" src="/assets/logos/logo.svg" />
        <div class="self-stretch text-center text-xl font-bold font-bree leading-normal">
          {{ 'ONBOARDING.REGISTER.INSCRIPTIONS_CLOSED' | transloco }}
        </div>
      </div>
    }
  } @else {
    <div class="flex flex-col items-center justify-center gap-10">
      <img height="64" class="h-16" src="/assets/logos/logo.svg" />
      <div class="self-stretch text-center text-xl font-bold font-bree leading-normal">
        {{ 'ONBOARDING.REGISTER.NO_EDITION_ENABLED' | transloco }}
      </div>
    </div>
  }
</ion-content>
